import axios from "axios";

// Tworzymy instancj� klienta axios z bazowym URL do Twojego backendu
const api = axios.create({
    baseURL: "https://ipod.rodzgoda.slask.pl/api", // katalog api na serwerze
    withCredentials: true // je�li b�dziesz u�ywa� ciasteczek sesyjnych
});

export default api;